import { useQuery } from '@tanstack/react-query';

import {
  fetchMeisaiIssueVisitStatus,
  type MeisaiIssueVisitStatus,
} from '@/services/main/meisaiIssueSetting';
import { useClinicContext } from './useClinicContext';

/**
 * 令和8年法改正 No 5 — drives three things on the visit form:
 *
 *   ・hiding the 明細書発行加算 checkbox on a 月別 patient's follow-up visits
 *   ・the UAT No18 confirm, when saving would leave the month with no billing day
 *   ・the 「※明細書発行加算日がありません。」 note after a save
 *
 * Disabled until a patient and a treatment date are both known — the form opens before
 * either is chosen when adding a visit.
 */
export const useMeisaiIssueVisitStatus = (
  patientId: number | null | undefined,
  visitDate: string | null | undefined,
  visitId?: number | null
) => {
  const { tenant, clinicNumber } = useClinicContext();
  const enabled = Boolean(tenant && clinicNumber && patientId && visitDate);

  return useQuery<MeisaiIssueVisitStatus>({
    queryKey: ['meisai-issue-visit-status', tenant, clinicNumber, patientId, visitDate, visitId ?? null],
    queryFn: () =>
      fetchMeisaiIssueVisitStatus(tenant ?? '', clinicNumber ?? '', {
        patient_id: Number(patientId),
        visit_date: String(visitDate),
        ...(visitId ? { visit_id: visitId } : {}),
      }),
    enabled,
    // The month's state changes on every save, so never serve a stale answer to a confirm.
    staleTime: 0,
  });
};
